export enum RELEASE_NOTE_SCOPES {
  LMS = 1,
  TT4W = 2
}
